import { keepPreviousData, QueryClient } from '@tanstack/react-query'
import { ApiError, NetworkError } from '../api/errors'

/**
 * The design has no spinners and no skeletons anywhere. That is the architecture, not
 * an omission — the queued state is the loading state. So queries keep serving their
 * last value while refetching, and writes never go through React Query at all: they go
 * to the outbox, which owns retry and ordering.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 30 * 60_000,
      // Reads are cheap to repeat and the aisle network drops constantly.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.isSessionExpired) {
          return false
        }
        if (error instanceof NetworkError) {
          return false
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
      // Last known data stays on screen rather than flashing empty.
      placeholderData: keepPreviousData,
    },
    mutations: {
      retry: false,
    },
  },
})
